/**
 * @generated SignedSource<<81356af79314eb16af2554e5e001b56c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetBlockContentInput = {
  clientMutationId?: string | null;
  content: any;
  id: string;
};
export type ActionItemChangeContentMutation$variables = {
  input: SetBlockContentInput;
};
export type ActionItemChangeContentMutation$data = {
  readonly setBlockContent: {
    readonly block: {
      readonly entityRanges: any;
      readonly id: string;
      readonly text: string;
      readonly updatedAt: string | null;
    };
    readonly note: {
      readonly entityMap: any;
      readonly id: string;
    };
  } | null;
};
export type ActionItemChangeContentMutation = {
  response: ActionItemChangeContentMutation$data;
  variables: ActionItemChangeContentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityMap",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteBlock",
  "kind": "LinkedField",
  "name": "block",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityRanges",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActionItemChangeContentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetBlockContentPayload",
        "kind": "LinkedField",
        "name": "setBlockContent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActionItemChangeContentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetBlockContentPayload",
        "kind": "LinkedField",
        "name": "setBlockContent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "023ecfa65f0acea1d361dfccb2a9911d",
    "id": null,
    "metadata": {},
    "name": "ActionItemChangeContentMutation",
    "operationKind": "mutation",
    "text": "mutation ActionItemChangeContentMutation(\n  $input: SetBlockContentInput!\n) {\n  setBlockContent(input: $input) {\n    note {\n      __typename\n      id\n      entityMap\n    }\n    block {\n      id\n      entityRanges\n      text\n      updatedAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "42fa18ef474a581f41c59c0bcdc1d15f";

export default node;
